// extracted by mini-css-extract-plugin
module.exports = {"Articles":"Articles_Articles__EJ9Et","SingleArticle":"Articles_SingleArticle__1pRjW"};